export default "__VITE_ASSET__BqEtZdHF__"